import axios from 'axios';
import { getCcToEcPageHeaders, interceptEcRedirect } from 'helpers/ccToEcRedirect';
import { toRailApiUrl, withRailBasename } from 'helpers/rail';

const envApiUrl = import.meta.env.REACT_APP_BACKEND_MAIN_API_URL;

const API = axios.create({
  baseURL: envApiUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Route submission calls to the rail detected at boot (`consumer-submission…` →
 * `ec/consumer-submission…` on the EC rail), then add a trailing slash to every
 * request, otherwise backend redirects to trailing slash. While CC → EC redirects
 * are enabled, also tell the backend which page the call comes from.
 */
API.interceptors.request.use((config) => {
  const tmpConfig = config;

  if (tmpConfig.url) {
    tmpConfig.url = toRailApiUrl(tmpConfig.url);
  }

  if (tmpConfig.url?.at(-1) !== '/') {
    tmpConfig.url = `${tmpConfig.url}${tmpConfig?.url?.includes('?') ? '' : '/'}`;
  }

  Object.entries(getCcToEcPageHeaders()).forEach(([headerName, headerValue]) => {
    tmpConfig.headers[headerName] = headerValue;
  });

  return tmpConfig;
});

/**
 * Handle 470 "page moved to EC" and 503 maintenance mode responses
 */
API.interceptors.response.use(
  (response) => interceptEcRedirect(response) ?? response,
  (error) => {
    const ecRedirect = interceptEcRedirect(error.response);
    if (ecRedirect) {
      return ecRedirect;
    }
    if (error.response?.status === 503 && error.response?.data?.maintenance === true) {
      window.location.href = withRailBasename('/maintenance');
      // Never settles, so no caller shows an error while the page changes.
      return new Promise(() => {});
    }
    return Promise.reject(error);
  },
);

export default API;
